// extracted by mini-css-extract-plugin
module.exports = {"footerNav":"Footer_footerNav__vm8NG"};